import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const LOGIN_MUTATION = gql`
  mutation loginWithPassword($username: String!, $password: String!) {
    login(
      input: {
        provider: PASSWORD
        credentials: { username: $username, password: $password }
      }
    ) {
      authToken
      authTokenExpiration
      refreshToken
      refreshTokenExpiration
      user {
        roles {
          nodes {
            name
          }
        }
        firstName
        lastName
        email
        capabilities
      }
    }
  }
`;

export const useLoginMutation = () => {
  const [login, { data, loading, error }] = useMutation(LOGIN_MUTATION);

  const loginWithPassword = useCallback(async (username: string, password: string) => {
    try {
      const response = await login({
        variables: { username, password },
      });
      return response.data?.login;
    } catch (err) {
      throw new Error("Login Failed.");
    }
  }, [login]);

  return {
    loginWithPassword,
    data,
    loading,
    error,
  };
};
